import React, { useState, useEffect } from "react"
import { Row, Col, Card, CardBody, Input, Button, Table } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import { Link, useHistory } from "react-router-dom"
import ReactPaginate from "react-paginate"
import { URLS } from "../../Url"
import axios from "axios"

function Advertisements() {
  var GetAuth = localStorage.getItem("authUser")
  var TokenJson = JSON.parse(GetAuth)
  var TokenData = TokenJson.token
  var StoreId = TokenJson.storeId

  const [Product, setProduct] = useState([])

  useEffect(() => {
    GetDeals()
    Pop_up()
  }, [])

  const GetDeals = () => {
    var token = TokenData
    axios
      .post(
        URLS.GetAdvertisement,
        { StoreId },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setProduct(res.data.advertisements)
      })
  }

  const [Searchs, setSearchs] = useState([])

  const Search = e => {
    let myUser = { ...Searchs }
    myUser[e.target.name] = e.target.value
    setSearchs(myUser)
    var token = TokenData

    axios
      .post(
        URLS.GetAdvertisementSearch + `${e.target.value}`,
        {},

        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setProduct(res.data.advertisements)
      })
  }

  const [listPerPage] = useState(5)
  const [pageNumber, setPageNumber] = useState(0)

  const pagesVisited = pageNumber * listPerPage
  const lists = Product.slice(pagesVisited, pagesVisited + listPerPage)
  const pageCount = Math.ceil(Product.length / listPerPage)
  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }

  const history = useHistory()

  const EditProduct = data => {
    sessionStorage.setItem("Advertisementid", data._id)
    history.push("/EditAdvertisements")
  }

  const ViewProduct = data => {
    sessionStorage.setItem("Advertisementid", data._id)
    history.push("/ViewAdvertisements")
  }

  const Pop_up = () => {
    const location = sessionStorage.getItem("tost")
    if (location != "") {
      toast(location)
      sessionStorage.clear()
    } else {
      sessionStorage.clear()
    }
  }

  const DeleteData = data => {
    const confirmBox = window.confirm("Do you really want to Delete?")
    if (confirmBox === true) {
      DeleteDealData(data)
    }
  }
  const DeleteDealData = data => {
    var token = TokenData
    var remid = data._id
    axios
      .delete(URLS.DeleteAdvertisement + remid, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(
        res => {
          if (res.status === 200) {
            toast(res.data.message)
            GetDeals()
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast(error.response.data.message)
          }
        }
      )
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title="Bizzmate Supplier"
            breadcrumbItem="Advertisements"
          />
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <Row>
                    <Col>
                      <Link to="/AddAdvertisements">
                        <Button color="primary" size="sm">
                          New Advertisement{" "}
                          <i className="bx bx-plus-circle"></i>
                        </Button>
                      </Link>
                    </Col>
                    <Col>
                      <div style={{ float: "right" }}>
                        <Input
                          type="search"
                          name="search"
                          value={Searchs.search}
                          onChange={Search}
                          className="form-control"
                          placeholder="Search.."
                          autoComplete="off"
                        />
                      </div>
                    </Col>
                  </Row>
                  <div className="table-rep-plugin mt-4 table-responsive">
                    <Table hover className="table table-bordered mb-4 ">
                      <thead>
                        <tr className="text-center">
                          <th>SlNo</th>
                          <th>Image</th>
                          <th>Name</th>
                          <th>Advertisements Category Name</th>
                          <th>Priority </th>
                          <th>Price </th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {lists.map((data, key) => (
                          <tr key={key} className="text-center">
                            <td>{(pageNumber - 1) * 5 + key + 6}</td>
                            <td>
                              <img
                                src={URLS.Base + data.image}
                                width="80px"
                                className="img-thumbnail"
                              />
                            </td>
                            <td>{data.name}</td>
                            <td>{data.advcategoryName}</td>
                            <td>{data.advpriority}</td>
                            <td>{data.advprice}</td>
                            <td>
                              {data.status == "active" ? (
                                <>
                                  <b className="text-success">{data.status}</b>
                                </>
                              ) : (
                                <>
                                  <b className="text-danger">{data.status}</b>
                                </>
                              )}
                            </td>
                            <td>
                              {/* <Button
                                onClick={() => {
                                  EditProduct(data)
                                }}
                                size="sm"
                                className="m-1"
                                color="primary"
                                outline
                              >
                                <div className="d-flex"> */}
                              <i
                                className="bx bx-edit text-primary me-2 "
                                style={{
                                  fontSize: "22px",
                                  cursor: "pointer",
                                }}
                                title="Edit"
                                onClick={() => {
                                  EditProduct(data)
                                }}
                              ></i>
                              {/* </div>
                              </Button> */}
                              {/* <Button
                                onClick={() => {
                                  ViewProduct(data)
                                }}
                                size="sm"
                                className="m-1"
                                color="primary"
                                outline
                              > 
                                <div className="d-flex">*/}
                              <i
                                className="mdi mdi-eye-circle-outline text-primary me-2"
                                style={{
                                  fontSize: "22px",
                                  cursor: "pointer",
                                }}
                                title="View"
                                onClick={() => {
                                  ViewProduct(data)
                                }}
                              ></i>
                              {/* </div>
                              </Button> */}
                              {/* <Button
                                size="sm"
                                className="m-1"
                                color="primary"
                                onClick={() => {
                                  DeleteData(data)
                                }}
                                outline
                              > 
                                <div className="d-flex">*/}
                              <i
                                className="bx bx-trash text-primary"
                                style={{
                                  fontSize: "22px",
                                  cursor: "pointer",
                                }}
                                title="Delete"
                                onClick={() => {
                                  DeleteData(data)
                                }}
                              ></i>
                              {/* </div>
                              </Button> */}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <div
                      className="d-flex mt-3 mb-1"
                      style={{ float: "right" }}
                    >
                      <ReactPaginate
                        previousLabel={"Previous"}
                        nextLabel={"Next"}
                        pageCount={pageCount}
                        onPageChange={changePage}
                        containerClassName={"pagination"}
                        previousLinkClassName={"previousBttn"}
                        nextLinkClassName={"nextBttn"}
                        disabledClassName={"disabled"}
                        activeClassName={"active"}
                        total={lists.length}
                      />
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <ToastContainer />
        </div>
      </div>
    </React.Fragment>
  )
}

export default Advertisements
